module.exports = __webpack_public_path__ + "static/media/create_demand_interview.0b46e4c4.png";